module.exports = __webpack_public_path__ + "static/media/backgroundGradient.e5ba4bec.svg";